import { motion } from "framer-motion";
import { ExperienceCode } from "../../portfolio/ExperienceCode";

export const ExperienceSection = ({ t }) => {
  return (
    <div className="font-mono">
      <h2 className="text-2xl sm:text-3xl font-bold text-[var(--text)] mb-10">
        <span className="text-[var(--muted)]">[</span>
        <span className="text-[#FF5722]"> {t.experience.heading} </span>
        <span className="text-[var(--muted)]">]</span>
      </h2>

      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7 space-y-8">
          {t.experience.items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.04 }}
              data-testid={`experience-item-${i}`}
              className="group text-[13px] leading-relaxed border border-[var(--border)] hover:border-[#FF5722]/40 transition-colors p-5"
            >
              <div className="text-[var(--muted)]">{"{"}</div>
              <div className="pl-5">
                <span className="text-[var(--var)]">"role"</span>
                <span className="text-[var(--muted)]">: </span>
                <span className="text-base font-semibold text-[var(--text)] group-hover:text-[#FF5722] transition-colors">
                  "{item.role}"
                </span>
                <span className="text-[var(--muted)]">,</span>
              </div>
              <div className="pl-5">
                <span className="text-[var(--var)]">"company"</span>
                <span className="text-[var(--muted)]">: </span>
                <span className="text-[var(--str)]">"{item.company}"</span>
                <span className="text-[var(--muted)]">, </span>
                <span className="text-[var(--var)]">"location"</span>
                <span className="text-[var(--muted)]">: </span>
                <span className="text-[var(--str)]">"{item.location}"</span>
                <span className="text-[var(--muted)]">,</span>
              </div>
              <div className="pl-5">
                <span className="text-[var(--var)]">"date"</span>
                <span className="text-[var(--muted)]">: </span>
                <span className="text-[var(--fn)]">"{item.date}"</span>
                <span className="text-[var(--muted)]">,</span>
              </div>
              <div className="pl-5">
                <span className="text-[var(--var)]">"stack"</span>
                <span className="text-[var(--muted)]">: [</span>
                {item.tags.map((tag, ti) => (
                  <span key={tag}>
                    <span className="text-[var(--str)]">"{tag}"</span>
                    {ti < item.tags.length - 1 && <span className="text-[var(--muted)]">, </span>}
                  </span>
                ))}
                <span className="text-[var(--muted)]">]</span>
              </div>
              <div className="pl-5 mt-2 text-[var(--cm)]">
                {"// "}
                {item.description}
              </div>
              <div className="text-[var(--muted)]">{"},"}</div>
            </motion.div>
          ))}
        </div>

        <div className="hidden lg:block lg:col-span-5">
          <div className="sticky top-8">
            <ExperienceCode />
            <p className="mt-4 font-mono text-[11px] text-[var(--cm)]">
              {"// "}
              {t.experience.overline.toLowerCase()} — live coding
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
